const getDisplayTimeBySeconds = (seconds) => {
    const min = Math.floor(seconds / 60);
    const sec = seconds % 60;
    return `${getDisplayableTime(min)}:${getDisplayableTime(sec)}`;
};

function getDisplayableTime(timeValue) {
    return timeValue < 10 ? `0${timeValue}` : `${timeValue}`;
}

export {getDisplayTimeBySeconds};
